module.exports = __webpack_public_path__ + "static/media/vg.08f72b3a.svg";